import React from "react";
import StatusChip from "../../components/statusChip/StatusChip";

export const IMPORT_STATUS = {
  analysing: { bg: "info", label: "Reading..." },
  ready: { bg: "primary", label: "Ready to build" },
  building: { bg: "info", label: "Building..." },
  built: { bg: "warning", label: "Draft built" },
  publishing: { bg: "info", label: "Publishing..." },
  published: { bg: "success", label: "Published" },
  failed: { bg: "danger", label: "Failed" },
};

export const WORKING = ["analysing", "building", "publishing"];

export function ImportStatusChip({ status }) {
  const s = IMPORT_STATUS[status] || { bg: "secondary", label: status };
  return <StatusChip bg={s.bg} title={s.label} />;
}

export function formatDate(value) {
  if (!value) return "-";
  return new Date(value).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

export const ROLES = [
  { value: "ignore", label: "Don't import" },
  { value: "dp_zones", label: "Zoning (filled colours)" },
  { value: "village_boundaries", label: "Village boundaries" },
  { value: "survey_parcels", label: "Survey parcels (lines)" },
  { value: "tp_plots", label: "TP plots (lines)" },
  { value: "roads", label: "Roads (centre lines)" },
];
